import { interaction_arrows_chevronLeft } from '@lsg/icons';
import React from 'react';
import { fComp } from '../../utils/React.js';
import { ButtonGroupWrapper } from '../ButtonGroup/ButtonGroupWrapper.js';
import { DrawerWrapper } from '../Drawer/DrawerWrapper.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import { SectionPresentation } from '../Section/SectionPresentation.js';
import { HeaderContainerPresentation } from '../_HeaderContainer/HeaderContainerPresentation.js';

var defaultProps = {
  layout: "right",
  onCloseClick: function onCloseClick() {
    /* empty */
  }
};
// Todo: Accessibility. aria-labelledby seems to work but aria-descibedby doesnt.
// Instead of reading the text of the element, the onclose iconlink is read.
// ChromeVox issue? Depending on use case?
// But there are working examples: https://jqueryui.com/dialog/#modal-form
var LayerPresentation = fComp(function (props) {
  var id = props.id,
    children = props.children,
    closeLinkLabel = props.closeLinkLabel,
    layout = props.layout,
    noMargin = props.noMargin,
    className = props.className,
    onCloseClick = props.onCloseClick,
    open = props.open,
    onBackdropClick = props.onBackdropClick,
    buttons = props.buttons,
    htmlAttrs = props.htmlAttrs,
    isMobile = props.isMobile;
  return /*#__PURE__*/React.createElement(DrawerWrapper, {
    id: id,
    noMargin: noMargin,
    className: className,
    layout: "layer-".concat(layout),
    open: open,
    onBackdropClick: closeLinkLabel ? onBackdropClick || onCloseClick : undefined,
    htmlAttrs: htmlAttrs
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 4
    }
  }, /*#__PURE__*/React.createElement(HeaderContainerPresentation, {
    width: "layer",
    theme: "elevated",
    isMobile: !buttons && isMobile,
    topLeft: closeLinkLabel && /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true,
      direction: "collapse-xs"
    }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction_arrows_chevronLeft,
      onClick: onCloseClick
    }, closeLinkLabel)),
    topRight: buttons ? /*#__PURE__*/React.createElement(ButtonGroupWrapper, {
      noMargin: true,
      align: "right"
    }, buttons) : undefined
  })), /*#__PURE__*/React.createElement(SectionPresentation, {
    look: layout === "right-25" ? "technical" : "marketing"
  }, children));
}, defaultProps);
LayerPresentation.displayName = "LayerPresentation";

export { LayerPresentation };
